import { render, staticRenderFns } from "./PatternsManagement.vue?vue&type=template&id=4857ec3c&scoped=true"
import script from "./PatternsManagement.vue?vue&type=script&lang=js"
export * from "./PatternsManagement.vue?vue&type=script&lang=js"
import style0 from "./PatternsManagement.vue?vue&type=style&index=0&id=4857ec3c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857ec3c",
  null
  
)

export default component.exports